import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      imgUrl: ''
    };
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '20px'
    },
    height: {
      type: String,
      default: '20px'
    }
  },
  methods: {
    getIcon: function getIcon(icon) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;
                _context.next = 3;
                return _this.$API.getRequest({
                  url: "/platform/file/downLoadPicture/".concat(icon)
                }).then(function (res) {
                  if (res.code === '0000000000') {
                    that.imgUrl = "data:image/svg+xml;base64,".concat(res.result);
                  }
                });
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {
    // this.getIcon(this.icon)
  },
  watch: {
    icon: {
      handler: function handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getIcon(newVal);
        }
      },
      immediate: true
    }
  }
};